export default {
  lang: {
    confirm: {
      title: 'Weet u zeker dat u het wilt verwijderen? Je kunt het niet herstellen na verwijdering',
      okText: 'Verwijderen',
      cancelText: 'Annuleer',
    },
  },
};
